<template>
    <div :id="id" v-on="listeners" v-bind="$attrs">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        id: [String, Number]
    },
    computed: {
        listeners() {
            return { 
                ...this.$listeners,
                dragenter: e => {
                    if(!this.$listeners.dragenter) {
                        e.preventDefault()
                    } else {
                        this.$listeners.dragenter(e)
                    }
                },
                dragover: e => {
                    if(!this.$listeners.dragover) {
                        e.preventDefault()
                    } else {
                        this.$listeners.dragover(e)
                    }
                }
            }
        }
    }
}
</script>